/* CACHE-ROTATE: video-upgrade-trigger-fix-1786133477 */
/* window.__themeSafeHTML: small sanitizer for inserting merchant-authored richtext (block.settings.content) into the support-widget tree without enabling stored XSS. Shopify's richtext strips <script> on save, but onerror/onload/href="javascript:..." survive. Parse via DOMParser (no script execution), walk the tree, strip dangerous tags + event-handler attrs + javascript:/data:text/html URLs. Reused below in initSupportWidget. */
(function () {
  if (window.__themeSafeHTML) return;
  var DROP = {
    SCRIPT: 1,
    STYLE: 1,
    IFRAME: 1,
    OBJECT: 1,
    EMBED: 1,
    LINK: 1,
    META: 1,
    BASE: 1,
    FRAME: 1,
    FRAMESET: 1,
  };
  var DANGER = /^\s*(javascript|vbscript):|^\s*data:text\/html/i;
  function clean(node) {
    if (!node || node.nodeType !== 1) return;
    if (DROP[node.tagName]) {
      node.parentNode && node.parentNode.removeChild(node);
      return;
    }
    for (var i = node.attributes.length - 1; i >= 0; i--) {
      var a = node.attributes[i];
      var n = a.name.toLowerCase();
      if (n.indexOf('on') === 0) {
        node.removeAttribute(a.name);
        continue;
      }
      if (
        (n === 'href' ||
          n === 'src' ||
          n === 'xlink:href' ||
          n === 'formaction' ||
          n === 'action') &&
        DANGER.test(a.value || '')
      ) {
        node.removeAttribute(a.name);
      }
    }
    for (var c = node.firstChild; c; ) {
      var nx = c.nextSibling;
      if (c.nodeType === 1) clean(c);
      c = nx;
    }
  }
  window.__themeSafeHTML = function (el, html) {
    if (!el) return;
    if (typeof html !== 'string') {
      el.innerHTML = '';
      return;
    }
    try {
      var doc = new DOMParser().parseFromString('<body>' + html + '</body>', 'text/html');
      var b = doc.body;
      clean(b);
      el.innerHTML = '';
      while (b.firstChild) el.appendChild(b.firstChild);
    } catch (e) {
      el.textContent = String(html);
    }
  };
})();

(function () {
  function shouldUpgrade() {
    if (typeof navigator !== 'undefined' && navigator.connection && navigator.connection.saveData)
      return false;
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
        return false;
    } catch (e) {}
    if (typeof document !== 'undefined' && document.hidden) return false;
    var conn = (typeof navigator !== 'undefined' && navigator.connection) || null;
    if (conn) {
      if (
        conn.effectiveType === '2g' ||
        conn.effectiveType === 'slow-2g' ||
        conn.effectiveType === '3g'
      )
        return false;
      if (typeof conn.downlink === 'number' && conn.downlink > 0 && conn.downlink < 1.5)
        return false;
    }
    return true;
  }
  function defer(fn) {
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(fn);
      });
    } else {
      setTimeout(fn, 50);
    }
  }
  function upgradeImageToVideo(img) {
    if (!img || !img.parentNode) return;
    function findAttrByContains(token) {
      var attrs = img.attributes;
      for (var k = 0; k < attrs.length; k++) {
        if (attrs[k].name.indexOf(token) !== -1) return attrs[k].value;
      }
      return '';
    }
    function hasAttrContaining(token) {
      var attrs = img.attributes;
      for (var k = 0; k < attrs.length; k++) {
        if (attrs[k].name.indexOf(token) !== -1) return true;
      }
      return false;
    }
    var isMobile = window.innerWidth < 800;
    var mobileVideoEnabled = hasAttrContaining('data-mobile-video-enabled');
    var mp4Desktop = findAttrByContains('data-video-mp4') || '';
    if (mp4Desktop && img.getAttribute('data-video-mp4'))
      mp4Desktop = img.getAttribute('data-video-mp4');
    var mp4Mobile = img.getAttribute('data-video-mp4-mobile') || '';
    var webmDesktop = img.getAttribute('data-video-webm') || '';
    var webmMobile = img.getAttribute('data-video-webm-mobile') || '';
    var posterMobile = img.getAttribute('data-poster-mobile') || '';
    if (isMobile && !mobileVideoEnabled) return;
    var mp4 = isMobile && mp4Mobile ? mp4Mobile : mp4Desktop;
    var webm = isMobile && webmMobile ? webmMobile : webmDesktop;
    if (!mp4 && !webm) return;
    var poster = (isMobile && posterMobile) || img.currentSrc || img.getAttribute('src') || '';
    var video = document.createElement('video');
    video.muted = true;
    video.autoplay = true;
    video.playsInline = true;
    video.loop = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('aria-hidden', 'true');
    video.preload = 'auto';
    if (poster) video.poster = poster;
    video.className = img.className
      .replace(/\s*hm-hero__video--upgrade\s*/g, ' ')
      .replace(/\s*hm-slide__video--upgrade\s*/g, ' ')
      .trim();
    if (webm) {
      var s1 = document.createElement('source');
      s1.src = webm;
      s1.type = 'video/webm';
      video.appendChild(s1);
    }
    if (mp4) {
      var s2 = document.createElement('source');
      s2.src = mp4;
      s2.type = 'video/mp4';
      video.appendChild(s2);
    }
    img.parentNode.replaceChild(video, img);
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }
  function swapGif(img) {
    if (!img) return;
    var gif = img.getAttribute('data-gif-src');
    if (!gif) return;
    if (img.src === gif) return;
    img.src = gif;
    img.removeAttribute('data-gif-src');
    var wrapper = img.closest('[data-gif-defer]');
    if (wrapper) {
      var icon = wrapper.querySelector('[data-gif-play-icon]');
      if (icon) icon.style.display = 'none';
    }
  }
  function init() {
    if (!shouldUpgrade()) return;
    defer(function () {
      var videoTargets = document.querySelectorAll(
        'img.hm-hero__video--upgrade, img.hm-slide__video--upgrade, img[data-video-upgrade]'
      );
      for (var i = 0; i < videoTargets.length; i++) upgradeImageToVideo(videoTargets[i]);
    });
    var gifTargets = document.querySelectorAll('[data-gif-defer] img[data-gif-src]');
    if (gifTargets.length === 0) return;
    if (typeof IntersectionObserver === 'undefined') {
      defer(function () {
        for (var i = 0; i < gifTargets.length; i++) swapGif(gifTargets[i]);
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            var img = entries[i].target;
            io.unobserve(img);
            defer(
              (function (t) {
                return function () {
                  swapGif(t);
                };
              })(img)
            );
          }
        }
      },
      { rootMargin: '200px 0px' }
    );
    for (var j = 0; j < gifTargets.length; j++) io.observe(gifTargets[j]);
  }
  if (document.readyState === 'interactive' || document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();

document.addEventListener('DOMContentLoaded', function () {
  /* Generic reveal helper — replaces 7 nearly-identical init*Reveals functions
     (consolidated 2026-05-14). All variants flip `.in-view` when a target
     enters the viewport, then unobserve it. Options vary by page only in
     threshold/rootMargin. */
  function initReveals(scope, selector, opts) {
    var root = scope || document;
    var els = root.querySelectorAll(selector);
    if (!els.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in-view');
            io.unobserve(e.target);
          }
        });
      },
      opts || { threshold: 0.08, rootMargin: '0px 0px -30px 0px' }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  function initKenBurnsScrollFollow() {
    var els = document.querySelectorAll(
      '.hero__bg-image.bg-effect--ken-burns,' +
        '.hm-hero__bg-image.bg-effect--ken-burns,' +
        'video.bg-effect--ken-burns'
    );
    if (!els.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* Idempotency guard: this fn binds window scroll/resize + document visibilitychange.
       In designMode shopify:section:load fires repeatedly; we only need the bindings once. */
    if (window.__thKenBurnsBound) return;
    window.__thKenBurnsBound = true;
    var SPEED = 0.15;
    var SMOOTH = 0.08;
    var states = Array.prototype.slice.call(els).map(function (el) {
      return { el: el, target: 0, current: 0 };
    });
    var inViewSet = new Set();
    var rafId = null;
    var scrollPending = false;
    if (typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) inViewSet.add(entry.target);
            else inViewSet.delete(entry.target);
          });
          if (inViewSet.size) {
            scrollPending = true;
            startTick();
          }
        },
        { rootMargin: '100px 0px' }
      );
      states.forEach(function (s) {
        io.observe(s.el);
      });
    } else {
      states.forEach(function (s) {
        inViewSet.add(s.el);
      });
    }
    function updateTargets() {
      states.forEach(function (s) {
        if (!inViewSet.has(s.el)) return;
        var rect = s.el.getBoundingClientRect();
        s.target = -rect.top * SPEED;
      });
    }
    function tick() {
      if (scrollPending) {
        scrollPending = false;
        updateTargets();
      }
      var anyMoving = false;
      states.forEach(function (s) {
        if (!inViewSet.has(s.el)) return;
        var diff = s.target - s.current;
        if (Math.abs(diff) > 0.1) {
          s.current += diff * SMOOTH;
          s.el.style.translate = '0 ' + s.current.toFixed(2) + 'px';
          anyMoving = true;
        } else if (s.current !== s.target) {
          s.current = s.target;
          s.el.style.translate = '0 ' + s.current.toFixed(2) + 'px';
        }
      });
      rafId = anyMoving || scrollPending ? requestAnimationFrame(tick) : null;
    }
    function startTick() {
      if (rafId === null) rafId = requestAnimationFrame(tick);
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!inViewSet.size) return;
        scrollPending = true;
        startTick();
      },
      { passive: true }
    );
    window.addEventListener(
      'resize',
      function () {
        if (!inViewSet.size) return;
        scrollPending = true;
        startTick();
      },
      { passive: true }
    );
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      } else {
        if (inViewSet.size) {
          scrollPending = true;
          startTick();
        }
      }
    });
    updateTargets();
    startTick();
  }

  function initBannerReveal() {
    initReveals(document, '.photo-banner__img:not(.in-view)', { threshold: 0.1 });
  }

  function initAboutCounters(scope) {
    var root = scope || document;
    var counters = root.querySelectorAll('.about-container-v4-4 .counter');
    if (!counters.length) return;
    var animateCounter = function (el) {
      var target = parseInt(el.dataset.target, 10);
      if (isNaN(target)) return;
      var duration = 1600;
      var start = performance.now();
      var update = function (now) {
        var elapsed = now - start;
        var progress = Math.min(elapsed / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(eased * target);
        if (progress < 1) requestAnimationFrame(update);
      };
      requestAnimationFrame(update);
    };
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            animateCounter(e.target);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    counters.forEach(function (c) {
      obs.observe(c);
    });
  }

  function initTestimonials() {
    var track = document.getElementById('testimonialTrack');
    var dots = document.querySelectorAll('.testimonials-dot');
    if (!track || !dots.length) return;
    var isDown = false,
      startX,
      scrollLeft;
    var cachedCardW = 0;
    function computeCardW() {
      var c = track.querySelector('.testimonial-card');
      cachedCardW = c ? c.offsetWidth + 24 : 400;
    }
    computeCardW();
    track.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    document.addEventListener('mouseup', function () {
      isDown = false;
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX);
    });
    var updateDots = function () {
      if (!cachedCardW) return;
      var active = Math.round(track.scrollLeft / cachedCardW);
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === active);
      });
    };
    var wrapper = track.closest('.testimonials-track-wrapper');
    var prevBtn = wrapper && wrapper.querySelector('[data-testimonial-prev]');
    var nextBtn = wrapper && wrapper.querySelector('[data-testimonial-next]');
    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    var scrollTicking = false;
    function onScroll() {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        updateDots();
        updateArrows();
        scrollTicking = false;
      });
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (!cachedCardW) computeCardW();
        track.scrollTo({ left: i * cachedCardW, behavior: 'smooth' });
      });
    });
    if (prevBtn)
      prevBtn.addEventListener('click', function () {
        if (!cachedCardW) computeCardW();
        track.scrollBy({ left: -cachedCardW, behavior: 'smooth' });
      });
    if (nextBtn)
      nextBtn.addEventListener('click', function () {
        if (!cachedCardW) computeCardW();
        track.scrollBy({ left: cachedCardW, behavior: 'smooth' });
      });
    window.addEventListener(
      'resize',
      function () {
        computeCardW();
        updateArrows();
      },
      { passive: true }
    );
    updateArrows();
  }

  function initWhCounters(scope) {
    var root = scope || document;
    var counters = root.querySelectorAll('.wholesale-container-v4-4 .wh-counter');
    if (!counters.length) return;
    function animateCounter(el) {
      var target = parseInt(el.getAttribute('data-target'), 10);
      if (isNaN(target)) return;
      var duration = 1200;
      var start = performance.now();
      function step(now) {
        var t = Math.min((now - start) / duration, 1);
        var ease = 1 - Math.pow(1 - t, 3);
        el.textContent = Math.round(target * ease);
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            animateCounter(e.target);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    counters.forEach(function (c) {
      obs.observe(c);
    });
  }

  function initFormAutoScroll() {
    var success = document.querySelector('.wholesale-container-v4-4 .wh-form-success');
    if (success) {
      setTimeout(function () {
        var section = document.getElementById('wh-section--contact');
        if (section) section.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  }

  function initFqAccordion(scope) {
    var root = scope || document;
    var triggers = root.querySelectorAll('.faq-container-v1 .fq-item__trigger');
    if (!triggers.length) return;
    triggers.forEach(function (btn) {
      if (btn.dataset.thFqInit) return;
      btn.dataset.thFqInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.fq-item');
        var panel = item.querySelector('.fq-item__answer');
        var isOpen = item.classList.contains('open');
        document.querySelectorAll('.faq-container-v1 .fq-item.open').forEach(function (openItem) {
          openItem.classList.remove('open');
          openItem.querySelector('.fq-item__answer').style.maxHeight = '0';
          openItem.querySelector('.fq-item__trigger').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initFqNavigation() {
    var tabs = document.querySelectorAll('.faq-container-v1 .fq-tab');
    var sidebarLinks = document.querySelectorAll('.faq-container-v1 .fq-sidebar__link');
    var heroStats = document.querySelectorAll('.faq-container-v1 .fq-hero__stat');
    var categories = document.querySelectorAll('.faq-container-v1 .fq-category');
    if (!tabs.length && !categories.length) return;
    function setActive(cat) {
      tabs.forEach(function (t) {
        t.classList.toggle('active', t.dataset.cat === cat);
      });
      sidebarLinks.forEach(function (l) {
        l.classList.toggle('active', l.dataset.cat === cat);
      });
    }
    function scrollToCat(cat) {
      var el = document.getElementById(cat);
      if (!el) return;
      var tabBar = document.getElementById('fq--tabs');
      var offset = tabBar ? tabBar.offsetHeight + 24 : 24;
      var top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActive(btn.dataset.cat);
        scrollToCat(btn.dataset.cat);
      });
    });
    sidebarLinks.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActive(btn.dataset.cat);
        scrollToCat(btn.dataset.cat);
      });
    });
    heroStats.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var cat = a.getAttribute('href').replace('#', '');
        setActive(cat);
        scrollToCat(cat);
      });
    });
    if (categories.length) {
      var catObs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) setActive(e.target.id);
          });
        },
        { threshold: 0.35 }
      );
      categories.forEach(function (cat) {
        catObs.observe(cat);
      });
    }
  }

  function initSupportWidget() {
    var wrapper = document.querySelector('.support-page-v1');
    if (!wrapper) return;
    var dataScript = wrapper.querySelector(
      'script[type="application/json"][id^="cs-tree-data"]'
    );
    if (!dataScript) return;
    var data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      if (window.__thLog) window.__thLog('warn', '[SupportWidget] config parse failed', e);
      return;
    }

    /* safeUrl: reject any URL whose scheme is not http(s)/mailto/tel.
       Prevents javascript:/data:/vbscript: open-redirect XSS on any
       merchant-supplied URL we assign to a.href or cta.href below. */
    function safeUrl(u) {
      if (!u) return '#';
      try {
        var p = new URL(u, location.origin);
        return ['http:', 'https:', 'mailto:', 'tel:'].indexOf(p.protocol) > -1 ? u : '#';
      } catch (_) {
        return '#';
      }
    }

    var blocks = data.blocks || [];
    var roots = [];
    var stack = {};
    blocks.forEach(function (block) {
      var node = {
        title: block.title,
        questionText: block.questionText,
        content: block.content,
        showForm: block.showForm,
        redirectTo: block.redirectTo,
        buttonLabel: block.buttonLabel,
        buttonUrl: block.buttonUrl,
        bgColor: block.bgColor || '',
        textColor: block.textColor || '',
        colorScheme: block.colorScheme || '',
        children: [],
      };
      stack[block.level] = node;
      if (block.level === 1) {
        roots.push(node);
      } else {
        var parent = stack[block.level - 1];
        if (parent) parent.children.push(node);
      }
    });
    var contentArea = document.getElementById('cs-widget-content');
    var navContainer = document.getElementById('cs-nav-container');
    var breadcrumbContainer = document.getElementById('cs-breadcrumb-container');
    var formTemplate = document.getElementById('cs-contact-form-template');
    if (!contentArea) return;
    var navStack = [];
    var heroSection = document.getElementById('cs-support--hero');
    function scrollToEl(el, offset) {
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.scrollY - (offset || 80);
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
    function scrollToWidget() {
      if (window.innerWidth < 768) {
        var target =
          widgetHeadingEl && widgetHeadingEl.style.display !== 'none'
            ? widgetHeadingEl
            : breadcrumbContainer;
        scrollToEl(target, 20);
      }
    }
    function scrollToHero() {
      scrollToEl(heroSection, 80);
    }
    function applyBlockColors(el, node) {
      if (node.bgColor && node.bgColor !== 'rgba(0,0,0,0)')
        el.style.setProperty('--block-bg', node.bgColor);
      if (node.textColor && node.textColor !== 'rgba(0,0,0,0)')
        el.style.setProperty('--block-text', node.textColor);
      if (node.colorScheme) {
        el.classList.add('tier--' + node.colorScheme);
        el.classList.add('tier--explicit');
      }
    }
    function getBreadcrumbText() {
      if (!navStack.length) return 'User landed on contact form directly.';
      return navStack
        .map(function (s) {
          return s.title;
        })
        .join(' > ');
    }
    function renderBreadcrumbs() {
      breadcrumbContainer.innerHTML = '';
      if (!navStack.length) {
        breadcrumbContainer.style.display = 'none';
        return;
      }
      breadcrumbContainer.style.display = 'flex';
      var home = document.createElement('a');
      home.textContent = _themeLocale.decisionTree.home;
      home.className = 'cs-breadcrumb-item';
      home.onclick = function () {
        navStack = [];
        render(null);
        scrollToHero();
      };
      breadcrumbContainer.appendChild(home);
      navStack.forEach(function (item, idx) {
        var sep = document.createElement('span');
        sep.className = 'cs-breadcrumb-separator';
        sep.textContent = '>';
        breadcrumbContainer.appendChild(sep);
        var link = document.createElement('a');
        link.textContent = item.title;
        if (idx === navStack.length - 1) {
          link.className = 'cs-breadcrumb-current';
        } else {
          link.className = 'cs-breadcrumb-item';
          link.onclick = (function (i) {
            return function () {
              var target = navStack[i];
              navStack = navStack.slice(0, i);
              navigateTo(target.title, target.node);
            };
          })(idx);
        }
        breadcrumbContainer.appendChild(link);
      });
    }
    function navigateTo(title, node) {
      navStack.push({ title: title, node: node });
      render(node);
    }
    function injectForm() {
      if (!formTemplate) return;
      var clone = formTemplate.content.cloneNode(true);
      contentArea.appendChild(clone);
      var input = document.getElementById('cs_breadcrumb_input');
      if (input) input.value = getBreadcrumbText();
    }
    function renderNav() {
      navContainer.innerHTML = '';
      if (!navStack.length) return;
      var back = document.createElement('button');
      back.className =
        'button button--secondary button--ghost button--secondary__ghost';
      back.textContent =
        (navContainer.dataset.backText || '').trim() || _themeLocale.decisionTree.previous_step;
      back.onclick = function () {
        navStack.pop();
        var prev = navStack.pop();
        if (prev) {
          navigateTo(prev.title, prev.node);
        } else {
          navStack = [];
          render(null);
          scrollToHero();
        }
      };
      navContainer.appendChild(back);
      var reset = document.createElement('button');
      reset.className =
        'button button--primary button--' +
        (_settings.primaryButtonStyle || 'filled') +
        ' button--primary__' +
        (_settings.primaryButtonStyle || 'filled');
      reset.textContent =
        (navContainer.dataset.restartText || '').trim() || _themeLocale.decisionTree.start_over;
      reset.onclick = function () {
        navStack = [];
        render(null);
        scrollToHero();
      };
      navContainer.appendChild(reset);
    }
    var hasHeroCards = !!wrapper.querySelector('.cs-hero__cat[data-trigger]');
    var widgetHeadingEl = wrapper.querySelector('.cs-widget-heading');
    function render(node, skipScroll) {
      if (!skipScroll) scrollToWidget();
      contentArea.innerHTML = '';
      renderBreadcrumbs();
      renderNav();
      if (!node) {
        if (hasHeroCards) {
          if (widgetHeadingEl) widgetHeadingEl.style.display = 'none';
          var prompt = document.createElement('p');
          prompt.className = 'cs-home-prompt';
          prompt.textContent = _themeLocale.decisionTree.select_prompt;
          contentArea.appendChild(prompt);
        } else {
          if (widgetHeadingEl) widgetHeadingEl.style.display = '';
          var grid = document.createElement('div');
          grid.className = 'cs-choices-grid';
          roots.forEach(function (cat) {
            var btn = document.createElement('button');
            btn.className = 'cs-choice-btn';
            btn.textContent = cat.title;
            applyBlockColors(btn, cat);
            btn.onclick = function () {
              navigateTo(cat.title, cat);
            };
            grid.appendChild(btn);
          });
          contentArea.appendChild(grid);
        }
        return;
      }
      if (widgetHeadingEl) widgetHeadingEl.style.display = '';
      if (node.redirectTo) {
        var panel = document.createElement('div');
        panel.className = 'cs-response-panel';
        if (node.content) window.__themeSafeHTML(panel, node.content);
        var target = roots.find(function (r) {
          return r.title === node.redirectTo;
        });
        if (target) {
          var linkBtn = document.createElement('button');
          linkBtn.className = 'cs-choice-btn cs-internal-link-btn';
          linkBtn.textContent = _themeLocale.decisionTree.redirect.replace(
            '%target%',
            node.redirectTo
          );
          linkBtn.onclick = function () {
            navStack = [];
            navigateTo(target.title, target);
          };
          panel.appendChild(linkBtn);
        }
        contentArea.appendChild(panel);
        if (node.showForm) injectForm();
        return;
      }
      if (node.children.length > 0) {
        var heading = node.questionText || node.title;
        var step = document.createElement('div');
        step.className = 'cs-current-step';
        var h3 = document.createElement('h3');
        h3.textContent = heading;
        step.appendChild(h3);
        contentArea.appendChild(step);
        var allLinks = node.children.every(function (c) {
          return c.buttonUrl && !c.children.length && !c.content;
        });
        if (allLinks) {
          var linksList = document.createElement('ul');
          linksList.className = 'cs-links-panel';
          node.children.forEach(function (child) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.textContent = child.title;
            a.href = safeUrl(child.buttonUrl);
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            li.appendChild(a);
            linksList.appendChild(li);
          });
          contentArea.appendChild(linksList);
        } else {
          var choiceGrid = document.createElement('div');
          choiceGrid.className = 'cs-choices-grid';
          node.children.forEach(function (child) {
            if (child.buttonUrl && !child.children.length && !child.content) {
              var a = document.createElement('a');
              a.className = 'cs-choice-btn';
              a.textContent = child.title;
              a.href = safeUrl(child.buttonUrl);
              a.target = '_blank';
              a.rel = 'noopener noreferrer';
              a.style.textDecoration = 'none';
              applyBlockColors(a, child);
              choiceGrid.appendChild(a);
            } else {
              var btn = document.createElement('button');
              btn.className = 'cs-choice-btn';
              btn.textContent = child.title;
              applyBlockColors(btn, child);
              btn.onclick = (function (c) {
                return function () {
                  navigateTo(c.title, c);
                };
              })(child);
              choiceGrid.appendChild(btn);
            }
          });
          contentArea.appendChild(choiceGrid);
        }
        return;
      }
      if (node.content) {
        var respPanel = document.createElement('div');
        respPanel.className = 'cs-response-panel';
        window.__themeSafeHTML(respPanel, node.content);
        if (node.buttonLabel && node.buttonUrl) {
          var cta = document.createElement('a');
          cta.className =
            'button button--primary button--' +
            (_settings.primaryButtonStyle || 'filled') +
            ' button--primary__' +
            (_settings.primaryButtonStyle || 'filled');
          cta.textContent = node.buttonLabel;
          cta.href = safeUrl(node.buttonUrl);
          cta.target = '_blank';
          cta.rel = 'noopener noreferrer';
          cta.style.textDecoration = 'none';
          cta.style.display = 'inline-block';
          cta.style.marginTop = '1em';
          respPanel.appendChild(cta);
        }
        contentArea.appendChild(respPanel);
      }
      if (node.showForm) injectForm();
    }
    if (sessionStorage.getItem('csFormSubmitted') === 'true') {
      var minH = data.minReplyHours || '24';
      var maxH = data.maxReplyHours || '48';
      var replyText = _themeLocale.decisionTree.reply_time
        .replace('%min%', minH)
        .replace('%max%', maxH);
      contentArea.innerHTML = '';
      navContainer.innerHTML = '';
      breadcrumbContainer.innerHTML = '';
      breadcrumbContainer.style.display = 'none';
      var successPanel = document.createElement('div');
      successPanel.className = 'cs-success-panel';
      successPanel.innerHTML =
        '<p>' +
        (data.successTitle || _themeLocale.decisionTree.thank_you) +
        '</p>' +
        '<p>' +
        replyText +
        '</p>';
      var startOver = document.createElement('button');
      startOver.className =
        'button button--primary button--' +
        (_settings.primaryButtonStyle || 'filled') +
        ' button--primary__' +
        (_settings.primaryButtonStyle || 'filled');
      startOver.textContent =
        (navContainer.dataset.restartText || '').trim() || _themeLocale.decisionTree.start_over;
      startOver.onclick = function () {
        window.location.href = window.location.pathname;
      };
      successPanel.appendChild(startOver);
      contentArea.appendChild(successPanel);
      sessionStorage.removeItem('csFormSubmitted');
      return;
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#contact_form .button[type="submit"]');
      if (!btn) return;
      var form = btn.closest('form');
      if (form) {
        sessionStorage.setItem('csFormSubmitted', 'true');
      }
    });
    wrapper.addEventListener('click', function (e) {
      var btn = e.target.closest('.cs-hero__cat[data-trigger]');
      if (!btn) return;
      var label = btn.getAttribute('data-trigger');
      var cat = roots.find(function (r) {
        return r.title === label;
      });
      if (cat) {
        navStack = [];
        navigateTo(cat.title, cat);
        setTimeout(function () {
          var widgetHeading = document.querySelector('.cs-widget-heading');
          if (widgetHeading) {
            var top = widgetHeading.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }, 80);
      }
    });
    render(null, true);
  }

  function initPolSidebar() {
    var links = document.querySelectorAll('.pol-sidebar__link[data-pol-idx]');
    var sections = document.querySelectorAll('.pol-content .pol-section[id^="pol-s-"]');
    if (!links.length || !sections.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var idx = e.target.id.replace('pol-s-', '');
            links.forEach(function (l) {
              l.classList.toggle('active', l.dataset.polIdx === idx);
            });
          }
        });
      },
      { rootMargin: '-20% 0px -60% 0px', threshold: 0 }
    );
    sections.forEach(function (s) {
      io.observe(s);
    });
    links.forEach(function (l) {
      l.addEventListener('click', function (ev) {
        ev.preventDefault();
        var target = document.getElementById('pol-s-' + l.dataset.polIdx);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initHmFaq(scope) {
    var root = scope || document;
    var triggers = root.querySelectorAll('.home-container-v2 .hm-faq__trigger');
    if (!triggers.length) return;
    triggers.forEach(function (btn) {
      if (btn.dataset.hmFaqInit) return;
      btn.dataset.hmFaqInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.hm-faq__item');
        var panel = item.querySelector('.hm-faq__answer');
        var isOpen = item.classList.contains('open');
        document.querySelectorAll('.home-container-v2 .hm-faq__item.open').forEach(function (o) {
          o.classList.remove('open');
          o.querySelector('.hm-faq__answer').style.maxHeight = '0';
          o.querySelector('.hm-faq__trigger').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initHmHeroSlider(scope) {
    var root = scope || document;
    var el = root.querySelector('.hm-hero__swiper');
    if (!el) return;
    if (typeof Swiper === 'undefined') {
      document.addEventListener(
        'th:swiper:ready',
        function () {
          initHmHeroSlider(scope);
        },
        { once: true }
      );
      return;
    }
    if (el.swiper) el.swiper.destroy(true, true);
    var autoplay = el.dataset.autoplay === 'true';
    var speed = parseInt(el.dataset.speed, 10) || 5000;
    var prevBtn = el.querySelector('.hm-hero__arrow--prev');
    var nextBtn = el.querySelector('.hm-hero__arrow--next');
    var pag = el.querySelector('.hm-hero__pagination');
    var slideCount = el.querySelectorAll('.swiper-slide').length;
    var opts = {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      loop: slideCount > 1,
      speed: 600,
      navigation: prevBtn && nextBtn ? { prevEl: prevBtn, nextEl: nextBtn } : false,
      pagination: pag ? { el: pag, clickable: true } : false,
      autoplay: autoplay
        ? { delay: speed, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,
      on: {
        init: function () {
          var active = el.querySelector('.swiper-slide-active');
          if (active) active.classList.add('hm-hero__slide--active');
        },
        slideChangeTransitionStart: function () {
          el.querySelectorAll('.hm-hero__slide--active').forEach(function (s) {
            s.classList.remove('hm-hero__slide--active');
          });
        },
        slideChangeTransitionEnd: function () {
          var active = el.querySelector('.swiper-slide-active');
          if (active) {
            void active.offsetWidth;
            active.classList.add('hm-hero__slide--active');
          }
        },
      },
    };
    new Swiper(el, opts);
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      initAllReveals(e.target);
      initAboutCounters(e.target);
      initKenBurnsScrollFollow();
      initBannerReveal();
      initTestimonials();
      initWhCounters(e.target);
      initFqAccordion(e.target);
      initFqNavigation();
      initSupportWidget();
      initPolSidebar();
      initHmFaq(e.target);
      initHmHeroSlider(e.target);
    });
  }

  function compactJdgmReviewCounts() {
    document.querySelectorAll('.jdgm-prev-badge__text').forEach(function (el) {
      var text = el.textContent.trim();
      if (/^\(\d+\)$/.test(text)) return;
      var match = text.match(/^(\d+)/);
      if (match && parseInt(match[1]) > 0) {
        el.textContent = '(' + match[1] + ')';
        el.style.display = '';
      } else if (text.length > 0) {
        el.style.display = 'none';
      }
    });
  }

  function initJdgmCompactor() {
    compactJdgmReviewCounts();
    var jdgmRoot = document.querySelector('.jdgm-widget,[class*="jdgm-"]');
    if (!jdgmRoot) return;
    /* Judge.me is a third-party app. We never modify .jdgm-* DOM — we only run
       our own compactJdgmReviewCounts() helper when their badges actually mutate.
       Prior version: subtree observer on <main>/<body> fired compact on EVERY
       DOM change (carousel init, lazy images, reveals) → hundreds of full-page
       querySelectorAll('.jdgm-prev-badge__text') passes per page (~80-150ms TBT
       on collection pages). Fix: filter mutations to badge-relevant ones AND
       rAF-throttle so repeated mutations in one frame coalesce into one compact.
       Disconnect on jdgm:setup_complete (Judge.me fires this once after their
       widgets finish booting), with a 5s safety timeout in case the event
       never fires (e.g. Judge.me script blocked, removed, or app disabled). */
    var jdgmPending = false;
    var jdgmObserver = new MutationObserver(function (muts) {
      var hit = false;
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (
          t &&
          t.closest &&
          t.closest('.jdgm-prev-badge,.jdgm-widget,.jdgm-rev-widg,.jdgm-star')
        ) {
          hit = true;
          break;
        }
      }
      if (!hit) return;
      if (jdgmPending) return;
      jdgmPending = true;
      requestAnimationFrame(function () {
        jdgmPending = false;
        compactJdgmReviewCounts();
      });
    });
    jdgmObserver.observe(jdgmRoot.closest('main,body') || document.body, {
      childList: true,
      subtree: true,
    });
    var jdgmDisconnected = false;
    function disconnectJdgmObserver() {
      if (jdgmDisconnected) return;
      jdgmDisconnected = true;
      jdgmObserver.disconnect();
      compactJdgmReviewCounts();
    }
    document.addEventListener('jdgm:setup_complete', disconnectJdgmObserver, { once: true });
    setTimeout(disconnectJdgmObserver, 5000);
  }

  function initMkScrollTrap() {
    var row = document.querySelector('.product__row--marketplace');
    if (!row) return;
    if (window.innerWidth < 1025) return;
    var sidebar = row.querySelector('.mk-sidebar');
    var infoCol = row.querySelector('.mk-info');
    if (!sidebar) return;
    function getScrollTarget() {
      var sidebarOverflow = sidebar.scrollHeight - sidebar.clientHeight;
      return { el: sidebar, overflow: sidebarOverflow };
    }
    function isScrollable(target) {
      return target.overflow > 2;
    }
    function isAtBottom(el) {
      return el.scrollTop >= el.scrollHeight - el.clientHeight - 4;
    }
    function isAtTop(el) {
      return el.scrollTop <= 0;
    }
    function isRowInView() {
      var rect = row.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }
    function onWheel(e) {
      if (!isRowInView()) return;
      var target = getScrollTarget();
      if (!isScrollable(target)) return;
      var delta = e.deltaY;
      if (delta > 0 && !isAtBottom(target.el)) {
        e.preventDefault();
        target.el.scrollTop += delta;
      } else if (delta < 0 && !isAtTop(target.el)) {
        e.preventDefault();
        target.el.scrollTop += delta;
      }
    }
    row.addEventListener('wheel', onWheel, { passive: false });
    var resizeTimer;
    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (window.innerWidth < 1025) {
            row.removeEventListener('wheel', onWheel);
          }
        }, 150);
      },
      { passive: true }
    );
  }

  function initArticleV1() {
    var containers = document.querySelectorAll('.article-v1');
    if (!containers.length) return;
    var first = containers[0];
    var progressBar = first.querySelector('[data-av-progress]');
    var articleBody = first.querySelector('[data-av-body]');
    if (progressBar && articleBody) {
      var cachedBodyTop = 0;
      var cachedBodyHeight = 0;
      function recomputeBodyMetrics() {
        var bodyRect = articleBody.getBoundingClientRect();
        cachedBodyTop = bodyRect.top + window.scrollY;
        cachedBodyHeight = articleBody.offsetHeight;
      }
      function updateProgress() {
        var scrolled = window.scrollY - cachedBodyTop;
        var pct = cachedBodyHeight
          ? Math.min(Math.max((scrolled / cachedBodyHeight) * 100, 0), 100)
          : 0;
        progressBar.style.width = pct + '%';
      }
      var progressTicking = false;
      function onProgressScroll() {
        if (progressTicking) return;
        progressTicking = true;
        requestAnimationFrame(function () {
          updateProgress();
          progressTicking = false;
        });
      }
      recomputeBodyMetrics();
      window.addEventListener('scroll', onProgressScroll, { passive: true });
      window.addEventListener(
        'resize',
        function () {
          recomputeBodyMetrics();
          updateProgress();
        },
        { passive: true }
      );
      updateProgress();
    }
    if (typeof IntersectionObserver !== 'undefined') {
      containers.forEach(function (c) {
        initReveals(c, '.av-reveal:not(.in-view)');
      });
    } else {
      containers.forEach(function (c) {
        c.querySelectorAll('.av-reveal').forEach(function (el) {
          el.classList.add('in-view');
        });
      });
    }
    var copyBtn = first.querySelector('[data-av-copy-link]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = window.location.href;
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(url)
            .then(function () {
              copyBtn.setAttribute('aria-label', 'Copied!');
              setTimeout(function () {
                copyBtn.setAttribute('aria-label', 'Copy link');
              }, 2000);
            })
            .catch(function () {});
        }
      });
    }
  }

  function initAllReveals(scope) {
    initReveals(
      scope,
      '.about-container-v4-4 .reveal:not(.in-view), .wholesale-container-v4-4 .wh-reveal:not(.in-view), .contact-container-v1 .ct-reveal:not(.in-view), .faq-container-v1 .fq-reveal:not(.in-view), .reviews-container-v1 .rv-reveal:not(.in-view), .policy-container-v1 .pol-reveal:not(.in-view), .home-container-v2 .hm-reveal:not(.in-view), .article-v1 .av-reveal:not(.in-view), .search-v1 .sr-reveal:not(.in-view)'
    );
  }

  initFormAutoScroll();
  if (document.querySelector('.hm-hero__swiper')) {
    initHmHeroSlider();
  }
  var __idleInit = function () {
    try {
      initAllReveals();
    } catch (e) {}
    try {
      initKenBurnsScrollFollow();
    } catch (e) {}
    try {
      initBannerReveal();
    } catch (e) {}
    try {
      initAboutCounters();
    } catch (e) {}
    try {
      initTestimonials();
    } catch (e) {}
    try {
      initWhCounters();
    } catch (e) {}
    try {
      initFqAccordion();
    } catch (e) {}
    try {
      initFqNavigation();
    } catch (e) {}
    try {
      initSupportWidget();
    } catch (e) {}
    try {
      initPolSidebar();
    } catch (e) {}
    try {
      initHmFaq();
    } catch (e) {}
    try {
      initJdgmCompactor();
    } catch (e) {}
    try {
      initMkScrollTrap();
    } catch (e) {}
    try {
      initArticleV1();
    } catch (e) {}
  };
  if ('requestIdleCallback' in window) {
    requestIdleCallback(__idleInit, { timeout: 1500 });
  } else {
    setTimeout(__idleInit, 200);
  }
});
